import HeroBanner from "@resources/competition/hero-competition.jpg?format=webp&quality=80&width=4000;2560;2000;1600;1024;767;500&as=srcset&imagetools";
import HeroEstate from "@resources/competition/block.jpg?format=webp&quality=80&width=1600;1024;767;500&as=srcset&imagetools";

export const CompetitionVideo = () => {
    return (
        <div className="lg:min-h-screen lg:py-28 py-20 flex items-center justify-center relative overflow-hidden">
            <img
                srcSet={HeroBanner}
                alt="Hero"
                className="absolute top-0 w-full h-full object-cover z-0"
            />
            <div className="relative z-10 lg:px-20 px-4">
                <h3 className="lg:text-[60px] text-center lg:leading-[72px] text-h1sm uppercase tracking-[-0.6px] text-primary font-black mb-6">
                    Współpraca z gdańskim ASP przy wyborze docelowego projektu
                    muralu{" "}
                </h3>
                {/* <p className="text-primary text-xl font-semibold mb-14 text-center">
                    wybór prac finałowych - ASP, Unidevelopment
                </p> */}
                <div className="relative w-full pb-[56.25%] h-0 overflow-hidden">
                    <iframe
                        className="absolute top-0 left-0 w-full h-full"
                        src="https://www.youtube.com/embed/cQeqzrlszO8?si=Ttakw3d_YI-WVxkY"
                        title="Embedded video"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
        </div>
    );
};
